import React, { useMemo, useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { AiOutlinePlus, AiOutlineCheck } from "react-icons/ai";
function SearchTableOrders(props) {
  const { columnsData, tableData } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const [selected, setSelected] = useState(false)
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,

    prepareRow,

    setGlobalFilter,
    state,
  } = tableInstance;

  const { pageIndex, pageSize } = state;
  const selection = () => {
    console.log("running")
    const currentSelection = JSON.parse(sessionStorage.getItem("machineselection"));
    const newSelection = {
      "start": currentSelection.start,
      "end": currentSelection.end,
      "type": currentSelection.type,
      "fleetNumber": selected,
    }

    sessionStorage.setItem("machineselection", JSON.stringify(newSelection))
  }
  useEffect(() => {
    // This effect will be triggered whenever MachineSelection is updated
    selection();
  }, [selected]);
  return (
    <div className="h-full w-full">
      {/* Search */}
      <div
        onChange={(e) => setGlobalFilter(e.target.value)}
        className="flex w-3/4 items-center rounded-[10px] bg-white p-[8px] pt-[18px] shadow-2xl shadow-white dark:!bg-navy-800 dark:shadow-none md:ml-3 md:w-[400px]"
      >
        <div className="flex h-9 w-[400px] flex-grow items-center rounded-[10px] bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900">
          <FiSearch className="mx-2 h-4 w-4 !text-gray-700 dark:!text-white" />
          <input
            type="text"
            placeholder="Search...."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
          />
        </div>
      </div>
      {/* table */}
      <div className="mt-11 h-full w-full overflow-x-scroll xl:overflow-hidden">
        <table {...getTableProps()} className="w-full">
          <thead className="w-full">
            {headerGroups.map((headerGroup, index) => (
              <tr
                className=" items-center border-b border-gray-200 dark:!border-white/10"
                {...headerGroup.getHeaderGroupProps()}
                key={index}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className=" px-4 pb-[10px] text-xs text-gray-600 text-start"
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="w-full" {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr
                  className="border-b border-gray-200 dark:!border-white/10"
                  {...row.getRowProps()}
                  key={index}
                >
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "FLEET #") {
                      data = (
                        <div className="font-medium text-navy-700 dark:text-white">
                          {cell.value}
                        </div>
                      );
                    }
                    else if (cell.column.Header === "MAKE") {
                      data = (
                        <div className="font-medium text-navy-700 dark:text-white">
                          {cell.value}
                        </div>
                      );
                    } else if (cell.column.Header === "MODEL") {
                      data = (
                        <div className="font-medium text-navy-700 dark:text-white">
                          {cell.value}
                        </div>
                      );
                    } else if (cell.column.Header === "WEIGHT") {
                      data = (
                        <div className="font-medium text-navy-700 dark:text-white">
                          {cell.value}
                        </div>
                      );
                    } else if (cell.column.Header === "STATUS") {
                      data = (
                        <div
                          className={`flex h-7 w-[110px] items-center justify-center text-sm ${cell.value === 1
                            ? "bg-green-100 dark:bg-green-50"
                            : "bg-red-100 dark:bg-red-50"
                            } rounded-[10px] text-base font-bold `}
                        >
                          <div
                            className={`${cell.value === 1
                              ? "text-green-500 "
                              : "text-red-500"
                              } uppercase `}
                          >
                            Available
                          </div>
                        </div>
                      );
                    } else if (cell.column.Header === "DAY PRICE") {
                      data = (
                        <div className="font-medium text-navy-700 dark:text-white">
                          £{cell.value}
                        </div>
                      );
                    } else if (cell.column.Header === "ACTIONS") {
                      data = (


                        <button
                          onClick={() => {
                            console.log(row.original.fleetNumber);
                            setSelected(row.original.fleetNumber);

                          }}
                          id={cell.value}
                          className="linear flex items-center justify-center rounded-md bg-lightPrimary px-8 py-1 text-lg text-brand-500 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:!bg-navy-700 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20"
                        >
                          {selected == row.original.fleetNumber ? <AiOutlineCheck /> : <AiOutlinePlus />}
                        </button>
                      );
                    }
                    return (
                      <td
                        className=" mt-[20px] px-4 py-[16px]"
                        {...cell.getCellProps()}
                        key={index}
                      >
                        {data}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {/* pagination */}
        <div className="mt-2 flex h-20 w-full items-center justify-between px-6">
          <div className="text-sm text-gray-700">
            Showing {pageSize * pageIndex + 1} to{" "}
            {pageSize * (pageIndex + 1) <= tableData.length
              ? pageSize * (pageIndex + 1)
              : tableData.length}{" "}
            of {tableData.length} entries
          </div>

          <div>

          </div>
        </div>
      </div>

    </div>
  );
}

export default SearchTableOrders;
